import { render, staticRenderFns } from "./LoginRegister.vue?vue&type=template&id=2fe83652&scoped=true"
import script from "./LoginRegister.vue?vue&type=script&lang=js"
export * from "./LoginRegister.vue?vue&type=script&lang=js"
import style0 from "./LoginRegister.vue?vue&type=style&index=0&id=2fe83652&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe83652",
  null
  
)

export default component.exports